module.exports = __webpack_public_path__ + "static/icons/banner_vida_vehi_2.97f7a0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-home/banners/banner_vida_vehi_2.svg
// module id = 3NS5
// module chunks = 1